import {Component, inject, OnInit} from '@angular/core';
import {SettingsService} from 'src/app/services/settings.service';
import {FeedbackComponent} from '../../feedback/feedback.component';
import {StoreItemActions} from "../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../store/entities/store-item/store-item.model";
import {GET_RELATED_SITES} from "../../../store/entities/cms/related-site/related-site.graphql";
import {select, Store} from "@ngrx/store";
import {selectStoreItems} from "../../../store/entities/store-item/store-item.selectors";
import {AppState} from "../../../store/reducers";
import {Observable} from "rxjs";
import {RelatedSite} from "../../../store/entities/cms/related-site/related-site.model";
import {ContactUsModel} from "../../../store/entities/cms/contact-us/contact-us.model";
import {GET_CONTACT_US} from "../../../store/entities/cms/contact-us/contact-us.graphql";


@Component({
  selector: 'app-portal-footer',
  templateUrl: './portal-footer.component.html',
  styleUrls: ['./portal-footer.component.scss']
})
export class PortalFooterComponent implements OnInit {

  store = inject(Store<AppState>)
  relatedSites$: Observable<RelatedSite[]>;
  contactUs$: Observable<ContactUsModel[]>;
  currentYear = new Date().getFullYear();

  constructor(
    private settingsService: SettingsService
  ) {
  }

  ngOnInit(): void {

    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.relatedSite,
      query: GET_RELATED_SITES,
      filtering: {}
    }))
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.contactUs,
      query: GET_CONTACT_US,
      filtering: {}
    }))


    this.relatedSites$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.relatedSite)))
    this.contactUs$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.contactUs)))
  }


  getContactItemLists(contactUs: ContactUsModel) {
    return contactUs?.contact?.split('\n');
  }


  feedback(): void {
    this.settingsService.openDialogModal({
      component: FeedbackComponent,
      width: '55%',
      data: null
    })
  }


}
